<style>
.status-circle {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: inline-block;
}

.status-green {
  background-color: #28c76f;
}

.status-red {
  background-color: #ea5455;
}

.status-grey {
  background-color: #c2c2c2;
}

.status-yellow {
  background-color: #ff9f43;
}
</style>

<template>
  <div>
    <vs-table search stripe border description :data="table.data" :max-items="table.length" :sst="false"
      @change-page="handleChangePage" :total="table.total">
      <template slot="header">
        <vs-dropdown vs-trigger-click class="cursor-pointer">
          <div
            class="p-3 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{ this.table.start }} - {{ this.table.end }} of
              {{ this.table.total }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <vs-dropdown-menu>
            <vs-dropdown-item v-for="item in table.limits" :key="item" @click="handleChangelength(item)">
              <span>{{ item }}</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </template>

      <template slot="thead">
        <vs-th>Action</vs-th>
        <vs-th>Driver/Vehicle</vs-th>
        <vs-th>Session</vs-th>
        <vs-th>Handover</vs-th>
        <vs-th>POD Confirm</vs-th>
        <vs-th>Collection Complete</vs-th>
        <vs-th>Daily Closing</vs-th>
        <vs-th>Exception</vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <vs-td>
            <div class="flex gap-1 items-center">
              <vs-button @click="exceptionRequest(tr)" size="small" color="primary" icon-pack="feather" icon="icon-edit"
                title="Exception Request" />
            </div>
          </vs-td>
          <vs-td>{{ tr.personal.name }}</vs-td>
          <vs-td>
            <div v-if="tr.detail.start_session == null">
              No Session
            </div>
            <div v-else>
              <div>Start Session : {{ formatDateTime(tr.detail.start_session) }}</div>
              <div>End Session : {{ getEndSession(tr) }}</div>
            </div>
          </vs-td>
          <vs-td>{{ formatDateTime(tr.detail.last_tp_updated_at) }}</vs-td>
          <vs-td>
            <span :class="statusPOD(tr)"></span>
            <div>{{ formatDateTime(tr.detail.last_pod_updated_at) }}</div>
          </vs-td>
          <vs-td>
            <span :class="statusCIT(tr)"></span>
            <div>{{ formatDateTime(tr.detail.last_invoice_updated_at) }}</div>
          </vs-td>
          <vs-td>
            <span :class="statusClosing(tr)"></span>
            <div>{{ getTimeClosing(tr) }}</div>
          </vs-td>
          <vs-td>
            <!-- <div v-for="exception in tr.exception" :key="exception.id"> -->
            <div v-if="tr.exception.length != 0">
              <div>{{ tr.exception[0].code }}</div>
              <div>{{ stsExc(tr.exception[0]) }}</div>
              <div>{{ formatDateTime(tr.exception[0].updated_at) }}</div>
            </div>
            <!-- </div> -->
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>

    <vs-pagination style="padding-top: 5px" :total="table.totalPage" v-model="setPage" />
  </div>
</template>
<script>
import moment from "moment";
import { formatNumber } from "@/utils/common";
export default {
  data() {
    return {
      baseUrl: "/api/sfa/v1/daily-closing/driver",
      table: this.tableDefaultState(),
      date: "",
      driverIDs: "",
      details: [],
    };
  },
  methods: {
    formatNumber,
    async setDate(date) {
      this.date = date;
    },
    async setDriverIDs(driverIDs) {
      this.driverIDs = driverIDs;
    },
    tableDefaultState() {
      return {
        data: [],
        length: 10,
        page: 1,
        search: "",
        order: "id",
        sort: "desc",
        total: 0,
        totalPage: 0,
        totalSearch: 0,
        limits: [5, 10, 25, 50, 100, "All"],
        start: 1,
        end: 0,
        row_number_start: 1,
        row_number_end: 0,
      };
    },
    getEndSession(tr) {
      if (!tr.detail.end_session) return "-";

      return new Date(tr.detail.end_session) < new Date(tr.detail.start_session)
        ? "-"
        : this.formatDateTime(tr.detail.end_session);
    },
    statusPOD(row) {
      var html = "status-circle ";
      if (row.detail.total_rows == 0) {
        row.detail.status_pod = "grey";
        return html + "status-grey";
      }
      if (row.detail.is_pod_yellow) {
        row.detail.status_pod = "yellow";
        return html + "status-yellow";
      }
      if (row.detail.total_pod < row.detail.total_rows) {
        row.detail.status_pod = "red";
        return html + "status-red";
      } else if (row.detail.total_pod === row.detail.total_rows) {
        row.detail.status_pod = "green";
        return html + "status-green";
      }
    },
    statusCIT(row) {
      var html = "status-circle ";
      if (row.detail.total_rows == 0) {
        row.detail.status_cit = "grey";
        return html + "status-grey";
      }
      if (row.detail.total_rows != 0 && (row.detail.total_so != 0 && row.detail.total_so != null) && ((row.detail.sum_invoice + row.detail.sum_billing) >= row.detail.total_so)) {
        row.detail.status_cit = "green";
        return html + "status-green";
      } else if (row.detail.total_rows != 0 && row.detail.total_so != 0 && row.detail.total_cod != 0 && (row.detail.sum_billing == 0 || !row.detail.sum_billing)) {
        row.detail.status_cit = "red";
        return html + "status-red";
      } else if ((row.detail.total_so != 0 && row.detail.total_so != null) && (row.detail.sum_invoice + row.detail.sum_billing) < row.detail.total_so) {
        row.detail.status_cit = "yellow";
        return html + "status-yellow";
      }

    },
    statusClosing(row) {
      var html = "status-circle ";
      if (row.detail.status_daily != null) {
        row.detail.status_closing = row.detail.status_daily;
        return html + "status-" + row.detail.status_daily;
      }
      if (row.exception.length > 0 && row.exception[0].status == 2) {
        row.detail.status_closing = "yellow";
        return html + "status-yellow";
      } else if ((row.detail.total_pod < row.detail.total_rows) ||
        (row.detail.total_rows != 0 && row.detail.total_cod != 0 && row.detail.sum_billing == 0) ||
        (row.detail.total_so != 0 && (row.detail.sum_invoice + row.detail.sum_billing) < row.detail.total_so)) {
        row.detail.status_closing = "red";
        return html + "status-red";
      } else if ((row.detail.total_pod === row.detail.total_rows) &&
        (row.detail.total_rows != 0 && (row.detail.sum_invoice + row.detail.sum_billing) >= row.detail.total_so)) {
        row.detail.status_closing = "green";
        return html + "status-green";
      }
    },
    getTimeClosing(row) {
      if (row.exception.length > 0 && row.exception[0].status == 2) {
        return this.formatDateTime(row.exception[0].updated_at);
      }

      if ((row.detail.total_pod === row.detail.total_rows) &&
        (row.detail.total_rows != 0 && (row.detail.sum_invoice + row.detail.sum_billing) >= row.detail.total_so)) {
        return this.formatDateTime(row.detail.last_invoice_updated_at);
      }
    },
    stsExc(row) {
      if (!row || row.code == null) {
        return "";
      }
      if (row.status == 0) {
        return "Open";
      } else if (row.status == 1) {
        return "Waiting for Approval";
      } else if (row.status == 2) {
        return "Approved";
      } else if (row.status == 3) {
        return "Rejected";
      }
    },
    exceptionRequest(tr) {
      if (tr.detail.status_daily == "grey" || ((tr.detail.total_pod === tr.detail.total_rows) &&
        (tr.detail.total_rows != 0 && (tr.detail.sum_invoice + tr.detail.sum_billing) >= tr.detail.total_so))) {
        this.$vs.notify({
          title: "Info",
          text: "No exception needed for this driver",
          color: "warning",
          position: "top-right",
        });
        return;
      }
      this.$router.push({
        name: "driver-exception",
        query: {
          data: JSON.stringify(tr),
          date: this.date,
        },
      });
    },
    async getData() {
      if (this.date == "") {
        return;
      }
      this.$vs.loading();
      try {
        const response = await this.$http.get(this.baseUrl, {
          params: {
            date: this.date,
            driver_id: this.driverIDs,
            page: this.table.page,
            length: this.table.length,
            search: this.table.search,
            order: this.table.order,
            sort: this.table.sort,
          },
        });
        if (response.code == 200) {
          this.table.total = response.data.total_record;
          this.table.totalPage = response.data.total_page;
          this.table.totalSearch = response.data.total_record_search;
          this.table.length = response.data.total_record_per_page;
          this.table.row_number_start = response.data.row_number_start;
          this.table.row_number_end = response.data.row_number_end;
          this.details = response.data.records.details;
          this.exceptions = response.data.records.exceptions;
          const detailMap = {};
          this.details.forEach(d => {
            detailMap[d.driver_id] = d;
          });
          const exceptionMap = {};
          this.exceptions.forEach(e => {
            if (!exceptionMap[e.personal_id]) {
              exceptionMap[e.personal_id] = [];
            }
            exceptionMap[e.personal_id].push(e);
          });
          this.table.data = response.data.records.data.map(row => {
            return { ...row, detail: detailMap[row.id], exception: exceptionMap[row.id] || [] };
          });

          console.log(this.table.data)

          this.$vs.notify({
            title: "Success",
            text: response.message,
            color: "success",
            position: "top-right",
          });
        } else {
          this.$vs.notify({
            title: "Error",
            text: response.message,
            color: "danger",
            position: "top-right",
          });
        }
      } catch (error) {
        this.$vs.notify({
          title: "Error",
          text: error.message,
          color: "danger",
          position: "top-right",
        });
        console.log(error);
      }
      this.$vs.loading.close();
    },
    handleSearch(searching) {
      this.table.search = searching;
      this.table.page = 1;
      this.getData();
    },
    handleChangePage(page) {
      this.table.page = page;
      this.getData();
    },
    handleSort(key, active) {
      this.table.order = key;
      this.table.sort = active;
      this.getData();
    },
    handleChangelength(val) {
      this.table.length = val == "All" ? this.table.total : val;
      this.table.page = 1;
      this.getData();
    },
    setStartEnd() {
      let valStart =
        this.table.length * this.table.page - this.table.length + 1;
      if (valStart > this.table.total) {
        valStart = 1;
      }
      if (this.table.total == 0) {
        valStart = 0;
      }
      let valEnd = this.table.length * this.table.page;
      if (valEnd > this.table.total) {
        valEnd = this.table.total;
      }
      if (this.table.totalSearch < this.table.total) {
        valEnd = this.table.totalSearch;
      }

      this.table.start = valStart;
      this.table.end = valEnd;
    },
    formatDateTime(value) {
      if (!value || value.includes("0001-01-01")) {
        return "";
      }
      if (value) {
        return moment(value)
          .add(-7, "h")
          .utc()
          .local()
          .format("DD-MM-YYYY HH:mm:ss");
      }
    }
  },
  computed: {
    setPage: {
      get() {
        return this.table.page;
      },
      set(val) {
        this.handleChangePage(val);
      },
    },
  },
};
</script>
